import React, { lazy, Suspense } from 'react';

interface Opts {
  fallback: React.ReactNode;
}
type Unpromisify<T> = T extends Promise<infer P> ? P : never;

function retryImport<T>(importFunc: () => Promise<T>) {
  return importFunc().catch(error => {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk');

    if (isChunkError) {
      const hasReloaded = sessionStorage.getItem('app-reload');

      if (!hasReloaded) {
        sessionStorage.setItem('app-reload', 'true');
        window.location.reload();
      }
    }

    throw error;
  });
}
export const lazyLoad = <
  T extends Promise<any>,
  U extends React.ComponentType<any>,
>(
  importFunc: () => T,
  selectorFunc?: (s: Unpromisify<T>) => U,
  opts: Opts = { fallback: null },
) => {
  // let lazyFactory: () => Promise<{ default: U }> = importFunc;

  // if (selectorFunc) {
  //   lazyFactory = () =>
  //     importFunc().then(module => ({ default: selectorFunc(module) }));
  // }
  const lazyFactory = () =>
    retryImport(importFunc).then(module => {
      if (selectorFunc) {
        return { default: selectorFunc(module as Unpromisify<T>) };
      }
      // module đã có default rồi
      return module as { default: U };
    });
  const LazyComponent = lazy(lazyFactory);

  return (props: React.ComponentProps<U>): JSX.Element => (
    <Suspense fallback={opts.fallback!}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
